import { motion } from "framer-motion";
import { AlertTriangle, Clock, Users, TrendingDown } from "lucide-react";

const PROBLEMS = [
  {
    icon: Clock,
    title: "定型業務に時間を奪われている",
    description: "メール転記、請求書処理、日報集計——毎日繰り返される手作業が、本来注力すべき業務の時間を圧迫しています。",
  },
  {
    icon: Users,
    title: "属人化が進み、引き継ぎが困難",
    description: "特定の担当者しか分からない業務プロセスが増え、退職・異動のたびに業務が停滞するリスクを抱えています。",
  },
  {
    icon: TrendingDown,
    title: "ツールを入れても定着しない",
    description: "RPAやSaaSを入れたものの、現場に馴染まず放置。投資対効果が見えず、次の一手が打てない状況です。",
  },
  {
    icon: AlertTriangle,
    title: "AI活用の方法が分からない",
    description: "生成AIの可能性は感じているが、自社業務にどう適用すればいいか分からず、具体的な一歩が踏み出せません。",
  },
];

const fadeInUp = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
};

export function ProblemSection() {
  return (
    <section id="problems" className="py-14 sm:py-20 lg:py-28 bg-white">
      <div className="container">
        {/* Section Header */}
        <motion.div {...fadeInUp} transition={{ duration: 0.6 }} className="mb-10 sm:mb-16">
          <div className="flex items-center gap-3 sm:gap-4 mb-3 sm:mb-4">
            <div className="w-1.5 sm:w-2 h-7 sm:h-8 bg-[#E03030]" />
            <span className="text-[10px] sm:text-xs font-medium tracking-widest uppercase text-[#666666]" style={{ fontFamily: "'Inter', sans-serif" }}>
              Problems
            </span>
          </div>
          <h2 className="text-xl sm:text-2xl lg:text-4xl font-bold text-[#1A1A1A] mb-3 sm:mb-4">
            こんな課題、ありませんか？
          </h2>
          <p className="text-sm sm:text-base text-[#333333] max-w-2xl leading-relaxed">
            中小〜中堅企業の現場で、日々直面する業務課題。これらは「AIエージェント」で解決できる時代になりました。
          </p>
        </motion.div>

        {/* Problem Cards - 2x2 Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 lg:gap-8">
          {PROBLEMS.map((problem, i) => (
            <motion.div
              key={problem.title}
              {...fadeInUp}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="group bg-[#F9F9F9] p-5 sm:p-8 lg:p-10 border border-[#E0E0E0] hover:border-[#E03030] transition-all duration-300 hover:shadow-[0_4px_24px_rgba(0,0,0,0.06)]"
            >
              <div className="flex items-start gap-4 sm:gap-5">
                <div className="shrink-0 w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-[#FEF2F2] text-[#E03030] rounded-sm">
                  <problem.icon size={20} strokeWidth={1.5} className="sm:hidden" />
                  <problem.icon size={24} strokeWidth={1.5} className="hidden sm:block" />
                </div>
                <div>
                  <h3 className="text-base sm:text-lg font-bold text-[#1A1A1A] mb-1.5 sm:mb-2 group-hover:text-[#E03030] transition-colors">
                    {problem.title}
                  </h3>
                  <p className="text-xs sm:text-sm text-[#333333] leading-relaxed">
                    {problem.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
